<template lang="pug">
.v-compare-small.compare-small(:class="{'basket-small--empty': !compare.items.length}")
	.blur-wrap
		a.btn.btn--icon.btn--gray.btn-search(:href="!compare.items.length ? null : compare.link")
			.batton__icon
				v-svg-icon.icon-search(icon="compare")
			.basket-small__badge.badge.badge--primary(v-if="compare.items.length") {{compare.items.length}}
		.blur
</template>

<script>
export default {
	computed: {
		compare() {
			return this.$store.state.compare;
		}
	},
};
</script>